import { SetStateAction } from "react";
import { stdObject } from "../../../data/types/stdObject";
import { removeAccents } from "../../../utils/removeAccents";

export const filterTableList = (
  value: SetStateAction<string>,
  delayTime: boolean = false,
  dictCounter: any,
  packData: stdObject,
) => {
  const { windowValues, setWindowValues, modalData, dictList } = packData;

  if (delayTime) {
    setWindowValues({
      ...windowValues,
      search: value,
      table: [],
    });
    if (dictCounter) {
      clearTimeout(dictCounter);
    }
    dictCounter = setTimeout(
      () =>
        setWindowValues({
          ...windowValues,
          search: value,
          table:
            typeof value === "string" && (value !== "" || modalData.showAll)
              ? dictList[modalData.dict].list.filter((e: stdObject) =>
                  modalData.keysList.some(
                    (v: string) =>
                      !windowValues.codes.includes(e.code) &&
                      removeAccents(e[v]).includes(removeAccents(value)),
                  ),
                )
              : [],
        }),
      500,
    );
  } else {
    setWindowValues({
      search: value,
      table:
        typeof value === "string" && (value !== "" || modalData.showAll)
          ? modalData.table.filter((e: stdObject) =>
              modalData.keysList.some((v: string) =>
                removeAccents(e[v]).includes(removeAccents(value)),
              ),
            )
          : modalData.table,
    });
  }
};
